export default {
	root: {
		fontSize: 'inherit',
		margin: '0 2px',
		minWidth: '0',
		lineHeight: '100%',
		padding: '5px 10px',
		borderRadius: 6,
		letterSpacing: '0.02em'
	},
	contained: {
		boxShadow: 'none',
		backgroundColor: '#eef2ff',
		color: '#1e40af',
		'&:hover': {
			backgroundColor: '#e0e7ff',
			boxShadow: 'none'
		}
	},
	containedPrimary: {
		backgroundColor: '#3b82f6',
		color: '#fff',
		boxShadow: 'none',
		'&:hover': {
			backgroundColor: '#2563eb',
			boxShadow: 'none'
		}
	},
	containedSecondary: {
		backgroundColor: '#64748b',
		color: '#fff',
		boxShadow: 'none',
		'&:hover': {
			backgroundColor: '#475569',
			boxShadow: 'none'
		}
	},
	outlined: {
		padding: '5px 10px',
		borderColor: 'rgba(59,130,246,0.35)'
	},
	outlinedPrimary: {
		color: '#2563eb',
		border: '1px solid rgba(59,130,246,0.45)',
		'&:hover': {
			border: '1px solid #3b82f6',
			backgroundColor: 'rgba(59,130,246,0.06)'
		}
	},
	outlinedSecondary: {
		color: '#475569',
		border: '1px solid rgba(100,116,139,0.4)',
		'&:hover': {
			border: '1px solid #64748b',
			backgroundColor: 'rgba(100,116,139,0.06)'
		}
	},
	textPrimary: {
		color: '#2563eb'
	},
	sizeSmall: {
		padding: '5px 10px',
		margin: '-2px 0px'
	},
	outlinedSizeSmall: {
		padding: '5px 10px',
		margin: '-2px 0px'
	},
	containedSizeSmall: {
		padding: '5px 10px',
		margin: '-2px 0px'
	}
};
